module.exports = __webpack_public_path__ + "static/media/doc-emp.d3403c78.svg";